import { ApiAccount, ApiMember, ApiCard } from '../../../../openapi';

export function filterHomeEntities({
  accounts,
  cards,
  members,
}: {
  accounts: ApiAccount[];
  cards: ApiCard[];
  members: ApiMember[];
}) {
  const memberIds = members.reduce((acc: string[], member) => {
    if (member.membership.role === 'MEMBER') {
      acc.push(member.customer.id);
    }
    return acc;
  }, []);
  const nonMemberCards = cards.reduce((acc: ApiCard[], card) => {
    if (!memberIds.includes(card.cardHolderId)) {
      acc.push(card);
    }
    return acc;
  }, []);
  const nonMemberAccounts = accounts.reduce((acc: ApiAccount[], account) => {
    if (!memberIds.includes(account.holderId)) {
      acc.push(account);
    }
    return acc;
  }, []);

  return {
    cards: nonMemberCards,
    accounts: nonMemberAccounts,
  };
}
